// Веб-вклад модуля `essays` — проверка эссе.
//
// Самостоятельный инструмент: своего шага в спине темы нет, поэтому плиток
// воркспейса он не даёт. Вход в раздел — «Инструменты» сайдбара и лаунчер.

import { SECTION_ICONS, SECTION_TINT } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const essaysWebManifest = {
	id: "essays",
	icon: SECTION_ICONS.essay,
	labelKey: "nav.essays",
	tint: SECTION_TINT.essay,
	routes: ["/tools/essay"],

	// Баннер объясняет ВЫГОДУ через разграничение: во всех остальных разделах
	// ИИ производит материал, здесь — единственный раз — оценивает написанное
	// пользователем. Это и есть то, чего не видно из названия «Проверка эссе».
	intro: {
		titleKey: "essays:intro.title",
		bodyKey: "essays:intro.body",
		bulletKeys: ["essays:intro.bullets.0", "essays:intro.bullets.1", "essays:intro.bullets.2"],
	},

	nav: [
		{
			key: "essays",
			to: "/tools/essay",
			icon: SECTION_ICONS.essay,
			labelKey: "nav.essays",
			order: 90,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM essay_submissions WHERE user_id = ? AND deleted_at IS NULL",
			},
		},
	],

	launch: [
		{
			key: "essay",
			icon: SECTION_ICONS.essay,
			tint: SECTION_TINT.essay,
			titleKey: "launcher.essay",
			hintKey: "launcher.essayHint",
			to: "/tools/essay",
			search: { create: true },
			order: 90,
		},
	],
} satisfies WebModuleManifest;
